const defaultForm = [
  {
    label: 'Field 1',
    placehold: '请输入',
    type: 'input',
    fieldStr: 'field1', //v-model绑定的字段
  },
  {
    label: 'Field 2',
    required: true,
    placehold: '请输入',
    type: 'select',
    fieldStr: 'field2', //v-model绑定的字段
    optionDataKey: 'option1',
  },
  {
    label: 'Field 3',
    required: true,
    placehold: '请输入',
    type: 'selectSearch', //带搜索的下拉
    fieldStr: 'field3', //v-model绑定的字段
    optionDataKey: 'option2', //下拉数据的key
    searchUrl: '/conversation/getEnterpriseMemberAndExternalUserIdAndName',
  },
  {
    label: 'Field 4',
    placehold: '请输入',
    type: 'input',
    fieldStr: 'field4', //v-model绑定的字段
  },
  {
    label: 'Field 5',
    placehold: '请选择',
    type: 'date',
    fieldStr: 'field5', //v-model绑定的字段
  },
  {
    label: 'Field 6',
    placehold: '请选择',
    type: 'dateRange',
    fieldStr: 'field6', //v-model绑定的字段
  },
];
const messageForm = [
  {
    label: '发送人',
    placehold: '请输入',
    type: 'selectSearch',
    fieldStr: 'sendUser',
    originDataKey: 'memberData', //原始数据取值Key
    optionData: [], //过滤后显示的数据
  },
  {
    label: '接收人',
    required: true,
    placehold: '请输入',
    type: 'selectSearch',
    fieldStr: 'receiveUser',
    originDataKey: 'memberData', //原始数据取值Key
    optionData: [], //过滤后显示的数据
  },
  {
    label: '会话日期',
    type: 'dateRange',
    fieldStr: 'conversationDate',
  },
  {
    label: '聊天记录',
    placehold: '请输入',
    type: 'input',
    fieldStr: 'content',
  },
  {
    label: '聊天类型',
    placehold: '请选择',
    type: 'select',
    fieldStr: 'type',
    optionDataKey: 'chatType',
  },
  {
    label: '群名',
    placehold: '请输入',
    type: 'input',
    fieldStr: 'roomName',
  },
];

const productForm = [
  {
    label: '产品名称',
    placehold: '请输入',
    type: 'input',
    fieldStr: 'fundName',
  },
  {
    label: '产品代码',
    placehold: '请输入',
    type: 'input',
    fieldStr: 'fundCode',
  },
  {
    label: '产品性质',
    placehold: '请选择',
    type: 'selectDict',
    fieldStr: 'proNature',
    dictCode: 'proNature',
  },
  {
    label: '投资类型',
    placehold: '请选择',
    type: 'selectDict',
    fieldStr: 'investType',
    dictCode: 'investType',
  },
  {
    label: '产品风险',
    placehold: '请选择',
    type: 'selectDict',
    fieldStr: 'riskLevel',
    dictCode: 'riskLevel',
  },
  {
    label: '是否母产品',
    placehold: '请选择',
    type: 'select',
    fieldStr: 'isParent',
    options: [
      {
        val: 0,
        text: '是',
      },
      {
        val: 1,
        text: '否',
      },
    ],
  },
  {
    label: '审核状态',
    placehold: '请选择',
    type: 'select',
    fieldStr: 'isReview',
    options: [
      {
        val: 0,
        text: '未审核',
      },
      {
        val: 1,
        text: '已审核',
      },
      {
        val: 2,
        text: '已驳回',
      },
    ],
  },
  {
    label: '审核状态222',
    placehold: '请选择',
    type: 'selectSearch',
    fieldStr: 'filed2',
    fieldCode: ['name'],
    url:
      process.env.VUE_APP_CMS_CHATDATA +
      '/conversation/getEnterpriseMemberAndExternalUserIdAndName',
  },
  {
    label: '日期',
    placehold: '请选择',
    type: 'date',
    fieldStr: 'date1',
  },
  {
    label: '日期范围',
    placehold: '请选择',
    type: 'dateRange',
    fieldStr: 'date2',
  },
];

export default { defaultForm, messageForm, productForm };
